export const $themeColors = {}
export const $themeBreakpoints = {}
export const $themeConfig = {
  app: {
    appName: `${process.env.VUE_APP_TITLE}`, // Will update name in navigation menu (Branding)
    appUrl: `${process.env.VUE_APP_URL}`,
    appCode: `${process.env.VUE_APP_CODE}`,
    // eslint-disable-next-line
    appLogoImage: require(`@/assets/images/logo/brands/${
      process.env.VUE_APP_CODE
    }/logo.png`), // Will update logo in navigation menu (Branding)
  },
  layout: {
    isRTL: false,
    skin: 'light', // light, dark, bordered, semi-dark
    routerTransition: 'slide-fade', // zoom-fade, slide-fade, fade-bottom, fade, zoom-out, none
    type: 'vertical', // vertical, horizontal
    contentWidth: 'full', // full, boxed
    menu: {
      hidden: false,
      isCollapsed: false,
    },
    navbar: {
      // ? For horizontal menu, navbar type will work for navMenu type
      type: 'static', // static , sticky , floating, hidden
      backgroundColor: '', // BS color options [primary, success, etc]
    },
    footer: {
      type: 'static', // static, sticky, hidden
    },
    customizer: false,
    enableScrollToTop: true,
  },
}
